// let facetIndex = {"Subject: Topics" : 2, 
// "Subject: persons": 3, 
// "Subject: places": 4,
// "Author": 5,
// "Place of publication": 6,
// "Publisher": 7,
// "Date of Publication": 8,
// "Language": 9,
// "Technical Name": 10, 
// "classification": 11,
// };

const FacetIndex = require("./facetIndex");


$(function () {

  let opts = {
    language: "en-US",
    api: {
      endpoint: `https://digi.cats.uni-heidelberg.de/api`,
      apiuser: `anonymous`,
      apipass: `R49QfCdWKxsRq4O184Co`,
    },
    display: {
      detail_link_url_prefix: `https://digi.cats.uni-heidelberg.de/detail/`,
      detail_link_url_postfix: `?p=173,103,115`,
      detail_link_target_blank: true,
      detail_link_title: "easyDB",
    },
    elements: [
      // {
      //    type: 'carousel',
      //    carouselInit: function(el) {
      //      $(el).find(".owl-carousel").owlCarousel({
      //        loop: false,
      //        margin: 10,
      //        items: 1,
      //        dots: true,
      //        dotsEach: true,
      //        nav: true,
      //        rewind: true,
      //        navText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>','<i class="fa fa-angle-right" aria-hidden="true"></i>'],
      //        navContainer: '.ep-carousel .custom-nav',
      //      })
      //    },
      //    target: '#carousel',
      //    pools: [115],
      //    objecttypes: ['objekte'],
      //    tags: [3]
      // },
      {
        type: "fieldsearch",
        target: "#feldsuche",
        pools: [...Array(300).keys()],
        objecttypes: ["objekte"],

        aggregations: {
          // "objekte._reverse_nested:ressourcen:lk_objekt_id.res_lizenz/lizenzen":
          // {
          //   title: {
          //     "de-DE": "Rechtsstatus",
          //     "en-EN": "Legal status",
          //   },
          //   index: 0,
          //   field:
          //     "objekte._reverse_nested:ressourcen:lk_objekt_id.res_lizenz",
          //   limit: 10,
          //   sort: "count",
          //   type: "linked_object",
          // },
          // 'objekte._nested:objekte__obj_aufbewahrorte_lok.obj_aufbewahrort_lok/lokal_klass_ort':
          // {
          //   title: {
          //     'de-DE': 'Collections',
          //     'en-US': 'Collections'
          //   },
          //   index: 1,
          //   field: 'objekte._nested:objekte__obj_aufbewahrorte_lok.obj_aufbewahrort_lok',
          //   filter_parent: null,
          //   limit: 100,
          //   sort: 'count',
          //   type: 'linked_object'
          // },
          "objekte._nested:objekte__obj_aufbewahrorte_lok.obj_aufbewahrort_lok/lokal_klass_ort":
          {
            title: {
              "de-DE": "Collection",
              "en-EN": "Collection",
            },
            index: 1,
            filter_parent: null,
            field: "objekte._nested:objekte__obj_aufbewahrorte_lok.obj_aufbewahrort_lok",
            sort: "count",
            type: "linked_object",
          },
          "objekte._nested:objekte__obj_schlagworte_lok.obj_schlagwort_lok/lokal_klass_sach":
          {
            title: {
              "de-DE": "Subject/Classification",
              "en-EN": "Subject/Classification",
            },
            index: 1,
            // index: FacetIndex.array['Subject: Topics'],
            filter_parent: null,
            field:
              "objekte._nested:objekte__obj_schlagworte_lok.obj_schlagwort_lok",
            limit: 10,
            sort: "count",
            type: "linked_object",
          },
          "objekte._nested:objekte__obj_dargestellte_personen.obj_dargestellte_person.conceptName":
          {
            title: {
              "de-DE": "Subject: persons",
              "en-EN": "Subject: persons",
            },
            index: 2,
            field:
              "objekte._nested:objekte__obj_dargestellte_personen.obj_dargestellte_person.conceptName",
            limit: 5,
            sort: "count",
            type: "term",
          },
          // "objekte._nested:objekte__obj_orte.obj_ort_gnd.conceptName": {
          //   title: {
          //     "de-DE": "Subject: places",
          //     "en-EN": "Subject: places",
          //   },
          //   index: 3,
          //   field: "objekte._nested:objekte__obj_orte.obj_ort_gnd.conceptName",
          //   limit: 10,
          //   sort: "count",
          //   type: "term",
          // },
          "objekte._nested:objekte__obj_autoren.obj_autor_gnd.conceptName": {
            title: {
              "de-DE": "Author/Creator",
            },
            title_suffix: {
              prefix: {
                "de-DE": " (from "
              },
              styled: {
                "de-DE": "GND"
              },
              link: "https://www.dnb.de/EN/Professionell/Standardisierung/GND/gnd_node.html",
              suffix: {
                "de-DE": ")"
              } 
            },
            index: 4,
            field:
              "objekte._nested:objekte__obj_autoren.obj_autor_gnd.conceptName",
            limit: 5,  
            sort: "count",
            type: "term",
          },
          "objekte._nested:objekte__obj_autoren_lok.obj_autor_lok&&lokal_klass_person": {
            title: {
            "de-DE": "Author/Creator (local list)",
            "en-US": "Author/Creator (local list)"
            },
            index: 5,
            filter_parent: null,
            field:
              "objekte._nested:objekte__obj_autoren_lok.obj_autor_lok",
            sort: "count",
            type: "linked_object",
            limit: 5
          },
          "objekte.obj_datierung_norm.from": {
            title: {
              "de-DE": "Year of publication",
              "en-US": "Year of publication",
            },
            highlight: {
              "pre_tag" : "HIHI",
              "post_tag" : "HIHI",
              "escape_html": false
            },
            index: 6,
            field: "objekte.obj_datierung_norm.from",
            filter_parent: null,
            format: "date",
            // limit: 0,
            ranges: [
              {
                from: "2023-01-01",
                to: "2023-12-31",
              },
              {
                from: "2024-01-01",
                to: "2024-12-31",
              },
              {
                from: "2025-01-01",
                to: "2025-12-31",
              },
              {
                from: "2026-01-01",
                to: "2026-12-31",
              },
              {
                from: "2027-01-01",
                to: "2027-12-31",
              },
              {
                from: "2028-01-01",
                to: "2028-12-31",
              },
              {
                from: "2029-01-01",
                to: "2029-12-31",
              },
              {
                from: "2030-01-01",
                to: "2030-12-31",
              },
              {
                from: "2031-01-01",
                to: "2031-12-31",
              },
              {
                from: "2032-01-01",
                to: "2032-12-31",
              },
              {
                from: "2033-01-01",
                to: "2033-12-31",
              },
              {
                from: "2034-01-01",
                to: "2034-12-31",
              },
              {
                from: "2035-01-01",
                to: "2035-12-31",
              },
              {
                from: "2036-01-01",
                to: "2036-12-31",
              },
              {
                from: "2037-01-01",
                to: "2037-12-31",
              },
              {
                from: "2038-01-01",
                to: "2038-12-31",
              },
              {
                from: "2039-01-01",
                to: "2039-12-31",
              },
              {
                from: "2040-01-01",
                to: "2040-12-31",
              },
              {
                from: "2041-01-01",
                to: "2041-12-31",
              },
              {
                from: "2042-01-01",
                to: "2042-12-31",
              },
              {
                from: "2043-01-01",
                to: "2043-12-31",
              },
              {
                from: "2044-01-01",
                to: "2044-12-31",
              },
              {
                from: "2045-01-01",
                to: "2045-12-31",
              },
              {
                from: "2046-01-01",
                to: "2046-12-31",
              },
              {
                from: "2047-01-01",
                to: "2047-12-31",
              },
              {
                from: "2048-01-01",
                to: "2048-12-31",
              },
              {
                from: "2049-01-01",
                to: "2049-12-31",
              },
              {
                from: "2050-01-01",
                to: "2050-12-31",
              },
              {
                from: "2051-01-01",
                to: "2051-12-31",
              },
              {
                from: "2052-01-01",
                to: "2052-12-31",
              },
              {
                from: "2053-01-01",
                to: "2053-12-31",
              },
              {
                from: "2054-01-01",
                to: "2054-12-31",
              },
              {
                from: "2055-01-01",
                to: "2055-12-31",
              },
              {
                from: "2056-01-01",
                to: "2056-12-31",
              },
              {
                from: "2057-01-01",
                to: "2057-12-31",
              },
              {
                from: "2058-01-01",
                to: "2058-12-31",
              },
              {
                from: "2059-01-01",
                to: "2059-12-31",
              },
              {
                from: "2060-01-01",
                to: "2060-12-31",
              },
              {
                from: "2061-01-01",
                to: "2061-12-31",
              },
              {
                from: "2062-01-01",
                to: "2062-12-31",
              },
              {
                from: "2063-01-01",
                to: "2063-12-31",
              },
              {
                from: "2064-01-01",
                to: "2064-12-31",
              },
              {
                from: "2065-01-01",
                to: "2065-12-31",
              },
              {
                from: "2066-01-01",
                to: "2066-12-31",
              },
              {
                from: "2067-01-01",
                to: "2067-12-31",
              },
              {
                from: "2068-01-01",
                to: "2068-12-31",
              },
              {
                from: "2069-01-01",
                to: "2069-12-31",
              },
              {
                from: "2070-01-01",
                to: "2070-12-31",
              },
              {
                from: "2071-01-01",
                to: "2071-12-31",
              },
              {
                from: "2072-01-01",
                to: "2072-12-31",
              },
              {
                from: "2073-01-01",
                to: "2073-12-31",
              },
              {
                from: "2074-01-01",
                to: "2074-12-31",
              },
              {
                from: "2075-01-01",
                to: "2075-12-31",
              },
              {
                from: "2076-01-01",
                to: "2076-12-31",
              },
              {
                from: "2077-01-01",
                to: "2077-12-31",
              },
              {
                from: "2078-01-01",
                to: "2078-12-31",
              },
              {
                from: "2079-01-01",
                to: "2079-12-31",
              },
              {
                from: "2080-01-01",
                to: "2080-12-31",
              },
              {
                from: "2081-01-01",
                to: "2081-12-31",
              },
              {
                from: "2082-01-01",
                to: "2082-12-31",
              },
              {
                from: "2083-01-01",
                to: "2083-12-31",
              },
              {
                from: "2084-01-01",
                to: "2084-12-31",
              },
              {
                from: "2085-01-01",
                to: "2085-12-31",
              },
              {
                from: "2086-01-01",
                to: "2086-12-31",
              },
              {
                from: "2087-01-01",
                to: "2087-12-31",
              },
              {
                from: "2088-01-01",
                to: "2088-12-31",
              },
              {
                from: "2089-01-01",
                to: "2089-12-31",
              },
              {
                from: "2090-01-01",
                to: "2090-12-31",
              },
              {
                from: "2091-01-01",
                to: "2091-12-31",
              },
              {
                from: "2092-01-01",
                to: "2092-12-31",
              },
              {
                from: "2093-01-01",
                to: "2093-12-31",
              },
              {
                from: "2094-01-01",
                to: "2094-12-31",
              },
              {
                from: "2095-01-01",
                to: "2095-12-31",
              },
              {
                from: "2096-01-01",
                to: "2096-12-31",
              },
              {
                from: "2097-01-01",
                to: "2097-12-31",
              },
              {
                from: "2098-01-01",
                to: "2098-12-31",
              },
              {
                from: "2099-01-01",
                to: "2099-12-31",
              },
              {
                from: "2100-01-01",
                to: "2100-12-31",
              },
              {
                from: "1900-01-01",
                to: "1909-12-31",
              },
              {
                from: "1910-01-01",
                to: "1919-12-31",
              },
              {
                from: "1920-01-01",
                to: "1929-12-31",
              },
              {
                from: "1930-01-01",
                to: "1939-12-31",
              },
              {
                from: "1940-01-01",
                to: "1949-12-31",
              },
              {
                from: "1950-01-01",
                to: "1959-12-31",
              },
              {
                from: "1960-01-01",
                to: "1969-12-31",
              },
              {
                from: "1970-01-01",
                to: "1979-12-31",
              },
              {
                from: "1980-01-01",
                to: "1989-12-31",
              },
              {
                from: "1990-01-01",
                to: "1999-12-31",
              },
              {
                from: "2000-01-01",
                to: "2009-12-31",
              },
              {
                from: "2010-01-01",
                to: "2019-12-31",
              },
              {
                from: "1000-01-01",
                to: "1099-12-31",
              },
              {
                from: "1100-01-01",
                to: "1199-12-31",
              },
              {
                from: "1200-01-01",
                to: "1299-12-31",
              },
              {
                from: "1300-01-01",
                to: "1399-12-31",
              },
              {
                from: "1400-01-01",
                to: "1499-12-31",
              },
              {
                from: "1500-01-01",
                to: "1599-12-31",
              },
              {
                from: "1600-01-01",
                to: "1699-12-31",
              },
              {
                from: "1700-01-01",
                to: "1799-12-31",
              },
              {
                from: "1800-01-01",
                to: "1899-12-31",
              },
            ],
            sort: "count",
            type: "date_range",
          },
          "objekte._nested:objekte__obj_herstellungsorte.obj_herstellungsort_gnd.conceptName": {
              title: {
                "de-DE": "Place of publication",
                "en-EN": "Place of publication",
              },
              index: 7,
              field:
                "objekte._nested:objekte__obj_herstellungsorte.obj_herstellungsort_gnd.conceptName",
              // limit: 0,
              sort: "count",
              type: "term",
            },
            "objekte._nested:objekte__obj_verlag_lok.obj_verlag_lok/lokal_klass_verlag": {
              title: {
              "de-DE": "Verlag",
              "en-US": "Publishing house"
              },
              index: 7,
              field:
                "objekte._nested:objekte__obj_verlag_lok.obj_verlag_lok",
              sort: "count",
              type: "linked_object",
              limit: 5
            },
          "objekte._nested:objekte__obj_sprachen.obj_sprache_gnd.conceptName": {
            title: {
              "de-DE": "Language",
            },
            index: 9,
            field:
              "objekte._nested:objekte__obj_sprachen.obj_sprache_gnd.conceptName",
            // limit: 0,
            sort: "count",
            type: "term",
          },
          "objekte._nested:objekte__obj_techniken.obj_technik.conceptName": {
            title: {
              "de-DE": "Technique",
              "en-EN": "Technique",
            },
            index: 10,
            field: "objekte._nested:objekte__obj_techniken.obj_technik.conceptName",
            limit: 5,
            sort: "count",
            type: "term",
          },
          "objekte.obj_sachbegriff.conceptName": {
            title: {
              "de-DE": "Work type",
              "en-EN": "Work type",
            },
            index: 11,
            field: "objekte.obj_sachbegriff.conceptName",
            limit: 5,
            sort: "count",
            type: "term",
          },
          "_linked._asset.class":
          {
            title: {
              "de-DE":"File type",
              "en-EN":"File type"
            },
            index: 12,
            field:
              "class",
            sort: "count",
            type: "asset",
            
},
                      // "objekte._reverse_nested:ressourcen:lk_objekt_id.res_datierung_norm.from":
          //   {
          //     title: {
          //       "de-DE": "Date of Publication",
          //       "en-US": "Date of Publication",
          //     },
          //     index:7,
          //     field:
          //       "objekte._reverse_nested:ressourcen:lk_objekt_id.res_datierung_norm.from",
          //     filter_parent: null,
          //     format: "date",
          //     limit: 100,
          //     ranges: [
          //       {
          //         from: "2019-01-01",
          //         to: "2019-12-31",
          //       },
          //       {
          //         from: "2018-01-01",
          //         to: "2018-12-31",
          //       },
          //       {
          //         from: "2017-01-01",
          //         to: "2017-12-31",
          //       },
          //       {
          //         from: "2016-01-01",
          //         to: "2016-12-31",
          //       },
          //       {
          //         from: "2015-01-01",
          //         to: "2015-12-31",
          //       },
          //     ],
          //     sort: "count",
          //     type: "date_range",
          //   },
          // "objekte._nested:objekte__obj_aufbewahrorte_lok.obj_aufbewahrort_lok/lokal_klass_ort":
          //   {
          //     title: {
          //       "de-DE": "Subject: Topics",
          //       "en-US": "Subject: Topics",
          //     },
          //     index: 2,
          //     field:
          //       "objekte._nested:objekte__obj_aufbewahrorte_lok.obj_aufbewahrort_lok",
          //     filter_parent: null,
          //     limit: 100,
          //     sort: "count",
          //     type: "linked_object",
          //   },
          // "objekte._nested:objekte__obj_fundorte_lok.obj_fundort_lok/lokal_klass_ort":
          //   {
          //     title: {
          //       "de-DE": "Fundort (lokal)",
          //     },
          //     index: 33,
          //     field:
          //       "objekte._nested:objekte__obj_fundorte_lok.obj_fundort_lok",
          //     filter_parent: null,
          //     limit: 100,
          //     sort: "count",
          //     type: "linked_object",
          //   },
        },
      },
    ],
  };
  window.app = new PortalCommon(opts);
});




//////////////////
// WEBPACK FOOTER
// ./js/PortalConnect.js
// module id = 22
// module chunks = 0